import script from "./ProjectTaskModify.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTaskModify.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTaskModify.vue?vue&type=style&index=0&id=17c416eb&lang=css"

const __exports__ = script;

export default __exports__